<template>
  <v-layout row>
    <v-flex xs8>
      <v-currency-field
        v-bind="currency_config"
        box
        v-model="value.value"
        :error-messages="errors.price"
        :label="label"
        background-color="white"
      ></v-currency-field>
    </v-flex>
    <v-flex xs4>
      <v-menu class="d-flex" left v-if="!only">
        <v-btn
          block
          dark
          slot="activator"
          class="ma-0"
          :style="btnStyle"
        >
          <div :class="flagClasses()"></div>
          {{value.currency}}
        </v-btn>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="subheading font-weight-thin text-xs-center">
              Escolha a moeda
            </v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile
            v-for="(item, index) in items"
            :key="index"
            @click="value.currency = item.currency">
            <v-list-tile-title>
              <div :class="`currency-flag currency-flag-${item.currency.toLowerCase()} mr-1`"></div>
              {{ item.currency }} <span class="body-1 font-weight-thin"> - {{ item.title }}</span>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'CalculatorField',
  props: {
    value: Object,
    btnStyle: String,
    label: String,
    only: Object
  },
  data(vm) {
    return {
      errors: {},
      currency_config: {
        decimal: ',',
        thousands: '.'
      },
      items: vm.allowedItems()
    }
  },
  methods: {
    allowedItems() {
      if (this.only) {
        return [this.only]
      } else {
        return [
          { title: 'Euro', currency: 'EUR' },
          { title: 'Real Brasileiro', currency: 'BRL' },
          { title: 'Dólar Americano', currency: 'USD' }
        ]
      }
    },
    flagClasses() {
      return `currency-flag currency-flag-${this.value.currency.toLowerCase()} mr-1`
    }

  }
}
</script>
<style>
  .currency-flag { width: 30px; border-radius: 2px; }
</style>



// WEBPACK FOOTER //
// src/CalculatorField.vue